import ListFilters from "@/common/components/ListFilters";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipments } from "@/features/equipments/hooks/useEquipments";
import { EquipmentsTransformer } from "@/features/equipments/services/equipmentTransformer";

const DashboardFilterEquipmentBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: equipmentOptions,
  } = useEquipments({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentsTransformer.optionsTransformer({
        showIcon: false,
      })
    }),
  });

  return (
    <ListFilters
      filters={[
        {
          className: 'bg-blue-200/20 rounded-xl shadow-none max-w-[200px] text-nowrap',
          placeholder: dashboardFilters[DashboardFilters.Equipment],
          options: [{ label: 'Todas', value: '' }, ...equipmentOptions],
          value: filters[DashboardFilters.Equipment],
          onChange: (e: any) => setFilters((prev) => ({ ...prev, [DashboardFilters.Equipment]: e?.value ? e : null })),
          onInputChange: setSearch,
        }
      ]}
    />
  );
}

export default DashboardFilterEquipmentBadge;
